import type { ThemeMode } from "../lib/theme";
import { resolveThemeMode } from "../lib/theme";
import { translations, type Locale } from "../lib/i18n";
import { Moon, Sun } from "lucide-react";

export function ThemeSwitcher({
  locale,
  mode,
  onChange,
}: {
  locale: Locale;
  mode: ThemeMode;
  onChange: (mode: ThemeMode) => void;
}) {
  const t = translations[locale];
  const activeMode = resolveThemeMode(mode);
  const options: Array<{
    value: Exclude<ThemeMode, "auto">;
    label: string;
    icon: typeof Sun;
  }> = [
    { value: "light", label: t.themeLightTooltip, icon: Sun },
    { value: "dark", label: t.themeDarkTooltip, icon: Moon },
  ];

  return (
    <div className="theme-switcher" role="group" aria-label={t.themeLabel}>
      {options.map((option) => {
        const Icon = option.icon;
        return (
          <button
            key={option.value}
            type="button"
            className={activeMode === option.value ? "active" : ""}
            onClick={() => onChange(option.value)}
            aria-label={option.label}
            title={option.label}
            data-tooltip={option.label}
            aria-pressed={activeMode === option.value}
          >
            <Icon size={16} strokeWidth={2.25} aria-hidden="true" />
          </button>
        );
      })}
    </div>
  );
}
